import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogConfig,
    MatDialogRef,
} from '@angular/material/dialog';
import { concatMap, finalize, from, toArray } from 'rxjs';
import { NotificationService } from 'src/app/shared/lib/notification/notification.service';
import { ConfirmarDialogUiComponent } from 'src/app/shared/ui/confirmar-dialog/confirmar-dialog.component';
@Component({
    selector: 'app-confirmar-dialog',
    standalone: true,
    imports: [ConfirmarDialogUiComponent],
    templateUrl: './confirmar-dialog.component.html',
    styleUrl: './confirmar-dialog.component.scss',
})
export class ConfirmarDialogComponent {
    loading: boolean = false;
    success: boolean = false;
    isthereChanges: boolean = false;
    errorMsg: string | null = null;
    result: any = null;
    totalTasks: number = 0;
    processedTasks: number = 0;
    progressPercent: number = 0;
    progressLabel: string = 'Procesando';

    constructor(
        public dialogRef: MatDialogRef<ConfirmarDialogComponent>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly notificationService: NotificationService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void { }

    openDialogDeleteVinculosMasivo(vinculados: any[]): void {
        const {
            selectedLength,
            successTitle,
            successSubTitle,
            errorTitle,
            errorSubTitle,
            modalTitle,
            modalMessage,
        } = this.data.myValidationMensajes(vinculados);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.width = '512px';
        dialogConfig.minHeight = '300px';
        dialogConfig.data = {
            selectedLength,
            modalTitle,
            modalMessage,
            myRequest: this.data.myAfterValidationsActions.bind(this),
            warn: true,
            mainButtonName: 'Eliminar',
        };

        const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.isthereChanges) {
                if (result.success) {
                    this.onConfirmMainRequest();
                } else {
                    this.notificationService.showErrorssAlertPersonalizadoAndAction(
                        errorTitle,
                        result.errorMsg || errorSubTitle,
                        () => {
                            this.loading = false;
                            this.OnClose();
                        }
                    );
                }
            } else {
                this.loading = false;
                this.OnClose();
            }
        });
    }

    async handleValidacion(): Promise<void> {
        try {
            const resultados: any[] = await Promise.all(this.data.myValidaciones());

            const vinculados =
                resultados
                    .map((r) => r.validarVinculoByOrdenCompraId)
                    .filter((i: any) => i.vinculado === true) ?? [];

            if (vinculados.length > 0) {
                this.openDialogDeleteVinculosMasivo(vinculados);
            } else {
                await this.onConfirmMainRequest();
            }
        } catch (error: any) {
            this.errorMsg = error.message || '';
            this.loading = false;
            this.changeDetectorRef.markForCheck();
        }
    }

    async onConfirmMainRequest(): Promise<void> {
        this.isthereChanges = true;

        try {
            const tasks: Array<Promise<any> | (() => Promise<any>)> = [
                ...this.data.myRequest(),
            ];

            if (this.data.mySubRequest) {
                tasks.push(...this.data.mySubRequest());
            }

            this.totalTasks = tasks.length;
            this.processedTasks = 0;
            this.progressPercent = 0;
            this.progressLabel = this.data.progressLabel || 'Procesando';
            this.changeDetectorRef.markForCheck();

            from(tasks)
                .pipe(
                    concatMap((task, index) => {
                        const currentTask =
                            typeof task === 'function' ? task() : Promise.resolve(task);
                        return currentTask
                            .then((res) => {
                                this.processedTasks += 1;
                                this.progressPercent = this.totalTasks
                                    ? Math.round((this.processedTasks / this.totalTasks) * 100)
                                    : 0;
                                this.changeDetectorRef.markForCheck();
                                return res;
                            })
                            .catch((error) => {
                                console.error(`[ConfirmarDialog] ❌ Promesa rechazada:`, error);
                                throw error;
                            });
                    }),
                    toArray(),
                    finalize(() => {
                        this.loading = false;
                        this.changeDetectorRef.markForCheck(); // Forzar detección para ocultar el spinner
                    })
                )
                .subscribe({
                    next: (results) => {
                        this.result = results;
                        this.success = true;
                        this.changeDetectorRef.markForCheck();
                        this.OnClose();
                    },
                    error: (error) => {
                        console.error('[ConfirmarDialog] 💥 Error:', error);
                        this.errorMsg = error;
                        this.success = false;
                        this.changeDetectorRef.markForCheck();
                        this.OnClose();
                    },
                    // complete: () => { console.log('[ConfirmarDialog] ✔️  Complete') },
                });
        } catch (e: any) {
            console.error('[ConfirmarDialog] 💥 Excepción:', e);
            this.errorMsg = e?.message || 'Error desconocido';
            this.success = false;
            this.loading = false;
            this.changeDetectorRef.markForCheck();
            this.errorMsg = "Ocurrió un error inesperado. Por favor, intenta nuevamente.";
            this.OnClose();
        }
    }

    async onSave(): Promise<void> {
        if (this.loading) return;
        this.loading = true;
        this.changeDetectorRef.markForCheck(); // Forzar detección de cambios para mostrar el spinner

        if (this.data.myValidaciones) {
            await this.handleValidacion();
        } else {
            await this.onConfirmMainRequest();
        }
    }

    OnClose(): void {
        this.dialogRef.close({
            success: this.success,
            isthereChanges: this.isthereChanges,
            errorMsg: this.errorMsg,
            result: this.result,
        });
    }

    onCancel(): void {
        this.loading = false;
        this.changeDetectorRef.markForCheck();
        this.OnClose();
    }

    ngOnDestroy(): void {
        this.OnClose();
    }
}